// extracted by mini-css-extract-plugin
export default {"btn":"A2jgHO","menuItem":"nUeowe"};